import { jsx as _jsx } from "react/jsx-runtime";
import { $path } from "../../../path.js";
export default function Link(props) {
    const { children, to, params, search, searchParams, hash, trailingSlash, ...anchorProps } = props;
    const href = $path({ to, params, search, searchParams, hash, trailingSlash });
    return (_jsx("a", { href: href, ...anchorProps, children: children }));
}
